/**
 * What the assistant is doing right now, in words. Shared by the drawer's
 * typing indicator and the launcher's tooltip so both say the same thing.
 *
 * The tool being executed is deliberately NOT named: a raw identifier like
 * `getMicVersion` reads as jargon on the shop floor. `activity` still gates the
 * wording, and the name can come back once the gateway sends a readable
 * `display_name` per tool.
 */
export const assistantActivityLabel = (t_, { activity = '', preparingAction = false }) => {
  if (preparingAction) {
    return t_('Getting the action ready for you...')
  }
  if (activity !== '') {
    return t_('Checking the data for you...')
  }
  return t_('Writing my answer...')
}
